var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuHamb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/MenuHamb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/MenuHamb",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2 C0,0.895625 0.767678571,0 1.71428571,0 L22.2857143,0 C23.2339286,0 24,0.895625 24,2 C24,3.10625 23.2339286,4 22.2857143,4 L1.71428571,4 C0.767678571,4 0,3.10625 0,2 Z M0,12 C0,10.89375 0.767678571,10 1.71428571,10 L22.2857143,10 C23.2339286,10 24,10.89375 24,12 C24,13.10625 23.2339286,14 22.2857143,14 L1.71428571,14 C0.767678571,14 0,13.10625 0,12 Z M22.2857143,24 L1.71428571,24 C0.767678571,24 0,23.10625 0,22 C0,20.89375 0.767678571,20 1.71428571,20 L22.2857143,20 C23.2339286,20 24,20.89375 24,22 C24,23.10625 23.2339286,24 22.2857143,24 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHamb);
export default __webpack_public_path__ + "static/media/MenuHamb.ac716fe2524a49585fb80903d61cdc16.svg";
export { ForwardRef as ReactComponent };